import { QueryClient } from '@tanstack/react-query';

// Single QueryClient for the app. Imported by main.tsx (provider) and by
// router.tsx (loader context) so route loaders can prefetch with the same
// cache the components read from. Keep this lean — per-resource hooks live
// under src/api/queries/ and src/api/mutations/ (PRD §9.4 + docs/
// frontend_architecture.md §5).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30s default keeps the candidate grid / shot list snappy across
      // navigation but still picks up new data on refocus. Per-query
      // overrides land alongside the resource hooks.
      staleTime: 30_000,
      retry: 1,
    },
  },
});
